import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import SignInForm from "../../components/auth/SignInForm";

export default function SignIn() {
  return (
    <>
      <PageMeta
        title="Sign In - Bullet Delivery"
        description="Sign in to your Bullet Delivery account to access the comprehensive delivery and logistics management dashboard. Manage orders, track packages, and handle logistics operations with advanced role-based permissions."
        keywords="sign in, login, delivery management, logistics platform, user authentication"
      />
      <AuthLayout>
        <SignInForm />
      </AuthLayout>
    </>
  );
}
